/**
 * AI Assist Module
 * Complete module for AI-powered user assistance with unified architecture
 * Supports Navigate, Guide, and Agent modes (Agent is foundation only)
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Chat Components
import { ChatWidgetComponent } from './chat/chat-widget.component';

// Navigate Components
import { CommandPaletteComponent } from './navigate/command-palette.component';
import { UnifiedCommandPaletteComponent } from './navigate/unified-command-palette.component';

// Guide Components
import { SpotlightOverlayComponent } from './components/spotlight-overlay/spotlight-overlay.component';
import { StepTooltipComponent } from './components/step-tooltip/step-tooltip.component';

// Directives
import { GuideableDirective } from './directives/guideable.directive';

// Core Services
import { SafetyGatekeeperService } from './core/safety-gatekeeper.service';
import { AppKnowledgeService } from './core/app-knowledge.service';
import { IntentClassifierService } from './core/intent-classifier.service';
import { ActionExecutorService } from './core/action-executor.service';
import { QuickActionsService } from './core/quick-actions.service';
import { UnifiedSearchService } from './core/unified-search.service';
import { FeatureDiscoveryService } from './core/feature-discovery.service';
import { OnboardingChecklistService } from './core/onboarding-checklist.service';

// Guide Services
import { WorkflowPlayerService } from './guide/workflow-player.service';
import { WorkflowRecorderService } from './guide/workflow-recorder.service';
import { ElementFinderService } from './guide/element-finder.service';

// API Service
import { AiAssistApiService } from './services/ai-assist-api.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    // Standalone components and directives
    ChatWidgetComponent,
    CommandPaletteComponent,
    UnifiedCommandPaletteComponent,
    SpotlightOverlayComponent,
    StepTooltipComponent,
    GuideableDirective
  ],
  exports: [
    ChatWidgetComponent,
    CommandPaletteComponent,
    UnifiedCommandPaletteComponent,
    SpotlightOverlayComponent,
    GuideableDirective
  ]
})
export class AiAssistModule {}
